import { StudentBadgesTab } from '@features/student-page/components/StudentBadgesTab'
import { requireRouteAudience } from '@services/router/routeAccess'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/students/$studentNo/badges')({
    component: RouteComponent,
    staticData: {
        crumb: {
            label: 'Badges',
        },
    },
    beforeLoad: requireRouteAudience(['staff'])
})

function RouteComponent() {
    const { studentNo } = Route.useParams()

    return <StudentBadgesTab studentNo={studentNo} />
}
